import {
  Grid,
  Typography,
  EditableInput,
  Tooltip,
} from '@prometheus/components';
import { FormLabel } from '@prometheus/features';
import { Documents } from '@prometheus/documents';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const OmopCdmSettings: FC<{
  entity: any;
  updateEntity: (newEntity: any, keyFile?: string, isAdmin?: boolean) => void;
}> = ({ entity, updateEntity }) => {
  const { t } = useTranslation();

  const handleSave = (fieldName: string) => (value: any) => {
    updateEntity({ ...entity, [fieldName]: value });
  };

  return (
    <>
      <Grid container spacing={2} item xs={12} p={2}>
        <Grid item xs={12} sm={6} container spacing={2}>
          <FormLabel
            htmlFor="cdm-schema"
            label={t('forms.cdm_schema')}
            required
          >
            <EditableInput
              value={entity.cdmSchema}
              className=""
              fullWidth
              id="cdm-schema"
              placeholder={t('forms.cdm_schema_placeholder')}
              size="small"
              onSubmit={handleSave('cdmSchema')}
              sx={{ ml: -1 }}
              onCancel={() => {}}
              color="textColor.primary"
              required
            />
          </FormLabel>
          <FormLabel
            htmlFor="resultSchema"
            label={t('forms.results_schema')}
            required
          >
            <EditableInput
              value={entity.resultSchema}
              className=""
              fullWidth
              id="resultSchema"
              placeholder={t('forms.results_schema_placeholder')}
              size="small"
              onSubmit={handleSave('resultSchema')}
              sx={{ ml: -1 }}
              onCancel={() => {}}
              color="textColor.primary"
              required
            />
          </FormLabel>
          <FormLabel htmlFor="targetSchema" label={t('forms.schema')}>
            <Tooltip
              text={
                'If Cohort Schema is not specified, Results Schema will be used instead'
              }
              color="primary"
              width="auto"
            >
              <EditableInput
                value={entity.targetSchema}
                className=""
                fullWidth
                id="targetSchema"
                placeholder={t('forms.schema_placeholder')}
                size="small"
                onSubmit={handleSave('targetSchema')}
                sx={{ ml: -1 }}
                onCancel={() => {}}
                color="textColor.primary"
              />
            </Tooltip>
          </FormLabel>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          container
          spacing={2}
          alignContent="flex-start"
        >
          {entity.type !== 'bigquery' ? (
            <>
              <FormLabel
                htmlFor="adminUsername"
                label={t('forms.admin_username')}
                required
              >
                <EditableInput
                  value={entity.adminCredentials?.username}
                  className=""
                  fullWidth
                  id="adminUsernamee"
                  placeholder={t('forms.admin_username_placeholder')}
                  size="small"
                  onSubmit={(newVal: any) => {
                    updateEntity({
                      ...entity,
                      adminCredentials: {
                        ...entity.adminCredentials,
                        username: newVal,
                      },
                    });
                  }}
                  sx={{ ml: -1 }}
                  onCancel={() => {}}
                  color="textColor.primary"
                  required
                />
              </FormLabel>
              <FormLabel
                htmlFor="adminPassword"
                label={t('forms.admin_password')}
                required
              >
                <EditableInput
                  value={entity.adminCredentials?.password}
                  className=""
                  fullWidth
                  id="adminPassword"
                  type="password"
                  placeholder={t('forms.admin_password_placeholder')}
                  size="small"
                  onSubmit={(newVal: any) => {
                    updateEntity({
                      ...entity,
                      adminCredentials: {
                        ...entity.adminCredentials,
                        password: newVal,
                      },
                    });
                  }}
                  sx={{ ml: -1 }}
                  onCancel={() => {}}
                  color="textColor.primary"
                  required
                />
              </FormLabel>
            </>
          ) : (
            <Grid item xs={12}>
              <Documents
                type="component"
                name="import-json-file"
                config={
                  {
                    titleButton: t('buttons.upload_keyfile'),
                    initialTextFile: entity?.adminKeyfileName,
                    onChange: (parsedJson: any, file: any) => {
                      updateEntity(entity, file, true);
                    },
                  } as any
                }
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};
